import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4-mini";

import { PatientMonitoringPage } from "@/uiKit/pages/PatientMonitoringPage.tsx";
import { Schema, cz } from "@/utils/zodUtils.ts";

type SearchOptions = {
  from?: string;
  to?: string;
  pump_profile?: string;
};

const searchOptionsSchema: Schema<SearchOptions> = z.object({
  from: cz.optional(z.iso.date()),
  to: cz.optional(z.iso.date()),
  pump_profile: cz.optional(z.string()),
});

export const Route = createFileRoute("/_practitioner/patients/$patientId/")({
  component: PatientMonitoringPage,
  validateSearch: (search): SearchOptions => searchOptionsSchema.parse(search),
});
